import { render, staticRenderFns } from "./RegistInformation.vue?vue&type=template&id=3f235a01&scoped=true&lang=pug&"
import script from "./RegistInformation.vue?vue&type=script&lang=ts&"
export * from "./RegistInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f235a01",
  null
  
)

export default component.exports